import "core-js/modules/es.number.constructor.js";
var BASE_TOPIC_KEY = 'topic';
export function browseTopicsQueryKey(topicId) {
  return [BASE_TOPIC_KEY, 'browse', topicId];
}
var topicKeys = {
  topics: [BASE_TOPIC_KEY],
  playlistTopics: function playlistTopics(selectedPlaylists) {
    return [BASE_TOPIC_KEY, 'playlist', selectedPlaylists];
  },
  singleTopic: function singleTopic(id) {
    return [BASE_TOPIC_KEY, 'single', Number(id)];
  },
  usersSearch: function usersSearch(query) {
    return [BASE_TOPIC_KEY, query];
  }
};
export default topicKeys;